import { Flex } from '@chakra-ui/react'

import { NAVIGATION_BAR_HEIGHT } from '@/components/NavigationBar/constants'
import { ComplianceBanner } from '@/features/resources/components/Banner'

import { logEvent } from '@/lib/gtm'

function Hero(): React.ReactElement {
  return (
    <Flex
      as="section"
      id="hero"
      sx={{
        w: 'full',
        minH: {
          base: `calc(100vh - ${NAVIGATION_BAR_HEIGHT.base})`,
          md: `calc(100vh - ${NAVIGATION_BAR_HEIGHT.md})`,
        },
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'white',
        backgroundImage: 'url("/images/resources/form/hero-bg.svg")',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: { base: '100% 10%', md: 'center' },
        backgroundSize: { base: 'auto 60%', md: '100% auto' },
        position: 'relative',
      }}
    >
      <ComplianceBanner
        onClickDownload={() => {
          logEvent({
            ga: {
              category: 'PDPA Guideline',
              action: 'Click CTA',
            },
          })
        }}
      />
    </Flex>
  )
}

export default Hero
